// 默认学生，当学生人数不足2个人时，使用下面虚拟学生填充
export const DefaultStudent = [
  {
    id: 'default1', // 学生ID
    realName: '学生1', // 学生真实名称
    name: '学生1', // 名称
    head: null, // 头像
    phone: '', // 手机号
    gradeId: '', // 年级id
    clazzId: '', // 班级id
    className: '', // 班级名称
    actStatus: 0, // 用户状态 0=正常 1=禁用
    schoolId: '', // 学校id
    schoolName: '', // 学校名称
    provinceId: '', // 省id
    cityId: '', // 市id
    districtId: '', // 区id
    loginAccount: '', // 登录账号，唯一，由后台自动生
    parentId: null, // 家长id
    kinshipTerms: null, // 学生针对某个家长的关系
    sequence: null, // 排序
    userType: null // 未知
  },
  {
    id: 'default2', // 学生ID
    realName: '学生2', // 学生真实名称
    name: '学生2', // 名称
    head: null, // 头像
    phone: '', // 手机号
    gradeId: '', // 年级id
    clazzId: '', // 班级id
    className: '', // 班级名称
    actStatus: 0, // 用户状态 0=正常 1=禁用， 2=注销中，3=已注销
    schoolId: '', // 学校id
    schoolName: '', // 学校名称
    provinceId: '', // 省id
    cityId: '', // 市id
    districtId: '', // 区id
    loginAccount: '', // 登录账号，唯一，由后台自动生
    parentId: null, // 家长id
    kinshipTerms: null, // 学生针对某个家长的关系
    sequence: null, // 排序
    userType: null // 未知
  }
]

export const bindStudentMockData = {
  '07b16955bf41a8a5d6e05eeff129ae85': [
    {
      id: '05B69708531F464782CB0505A06EDB58',
      realName: '测试啊啊啊',
      name: '王八蛋103',
      head: 'https://xiyou-sys-dev.oss-cn-shenzhen.aliyuncs.com/sys_head/student_default.png',
      phone: null,
      gradeId: '3',
      clazzId: '07b16955bf41a8a5d6e05eeff129ae85',
      className: '舔狗班',
      actStatus: 0,
      stutus: 0,
      schoolId: 'EB996DD0C9B5414C9CDDA67CC4FD5302',
      schoolName: '西柚测试中学',
      provinceId: '440000',
      cityId: '441900',
      districtId: '441907',
      loginAccount: '71312121',
      parentId: null,
      kinshipTerms: null,
      sequence: null,
      userType: null,
      expire: null,
      expireAt: '2025-09-04 00:00:00',
      memberType: 6005,
      type: 0,
      initialLetter: 67,
      isBindAnswerDevice: true, // 是否绑定答题器
      answerDeviceInfo: {
        bindTime: '2023-08-15 11:44:59', // 绑定时间，由time_stamp转换
        deviceSn: '893597773', // 接收器序列号，对应：dev_sn
        answerDeviceId: 351553135, // 刷卡的答题器 对应：uID
        answerDeviceType: 18 // 刷卡的答题器类型，对应：uID_t。 18：学生答题；50：教鞭；
      }
    },
    {
      id: '0bff6f037da7424880f582cd769beeff',
      realName: '陈六六',
      name: '16620048744',
      head: 'https://xiyou-sys-dev.oss-cn-shenzhen.aliyuncs.com/sys_head/student_default.png',
      phone: '13790889678',
      gradeId: '7',
      clazzId: '07b16955bf41a8a5d6e05eeff129ae85',
      className: '舔狗班',
      actStatus: 0,
      stutus: 0,
      schoolId: 'EB996DD0C9B5414C9CDDA67CC4FD5302',
      schoolName: '西柚测试中学',
      provinceId: '440000',
      cityId: '441900',
      districtId: '441907',
      loginAccount: '66666666',
      parentId: null,
      kinshipTerms: null,
      sequence: null,
      userType: null,
      expire: null,
      expireAt: '2025-04-03 00:00:00',
      memberType: 58150,
      type: 0,
      initialLetter: 67,
      isBindAnswerDevice: true,
      answerDeviceInfo: {
        bindTime: '2023-08-15 11:45:01',
        deviceSn: '893597773',
        answerDeviceId: 2488202861,
        answerDeviceType: 18
      }
    },
    // {
    //   id: 'efcad4258b054ec15e77497823765087',
    //   realName: '赤井秀一',
    //   name: '5382同学',
    //   head: null,
    //   phone: '13712345678',
    //   gradeId: '3',
    //   clazzId: '07b16955bf41a8a5d6e05eeff129ae85',
    //   className: '舔狗班',
    //   actStatus: 0,
    //   stutus: 0,
    //   schoolId: 'EB996DD0C9B5414C9CDDA67CC4FD5302',
    //   schoolName: '西柚测试中学',
    //   provinceId: '440000',
    //   cityId: '441900',
    //   districtId: '441907',
    //   loginAccount: '04865382',
    //   parentId: null,
    //   kinshipTerms: null,
    //   sequence: null,
    //   userType: null,
    //   expire: null,
    //   expireAt: '2024-06-15 00:00:00',
    //   memberType: 73671,
    //   type: 0,
    //   initialLetter: 67,
    //   isBindAnswerDevice: true,
    //   answerDeviceInfo: {
    //     bindTime: '2023-08-15 11:45:04',
    //     deviceSn: '893597773',
    //     answerDeviceId: 2052515693,
    //     answerDeviceType: 18
    //   }
    // },
    // {
    //   id: 'fe1e51ac39454988a33783f8a5aa94a2',
    //   realName: '陈微甜',
    //   name: '接口修改昵称',
    //   head: 'https://xiyou-sys-dev.oss-cn-shenzhen.aliyuncs.com/sys_head/student_default.png',
    //   phone: '13790889678',
    //   gradeId: '7',
    //   clazzId: '07b16955bf41a8a5d6e05eeff129ae85',
    //   className: '舔狗班',
    //   actStatus: 0,
    //   stutus: 0,
    //   schoolId: '1E8E996B8BAF4F52A7D65D5AD99FDCF4',
    //   schoolName: '西柚国际小学',
    //   provinceId: '440000',
    //   cityId: '441900',
    //   districtId: '441921',
    //   loginAccount: '88888888',
    //   parentId: null,
    //   kinshipTerms: null,
    //   sequence: null,
    //   userType: null,
    //   expire: null,
    //   expireAt: '2044-08-30 00:00:00',
    //   memberType: 96677,
    //   type: 0,
    //   initialLetter: 67,
    //   isBindAnswerDevice: true,
    //   answerDeviceInfo: {
    //     bindTime: '2023-08-15 11:45:07',
    //     deviceSn: '893597773',
    //     answerDeviceId: 2376631663,
    //     answerDeviceType: 18
    //   }
    // },
    // {
    //   id: '7919AE7905854D559323D8BC9BF657ED',
    //   realName: '尚元绿',
    //   name: '尚元绿',
    //   head: 'https://xiyou-sys-dev.oss-cn-shenzhen.aliyuncs.com/sys_head/student_default.png',
    //   phone: '13712345678',
    //   gradeId: '8',
    //   clazzId: '07b16955bf41a8a5d6e05eeff129ae85',
    //   className: '舔狗班',
    //   actStatus: 0,
    //   stutus: 0,
    //   schoolId: 'EB996DD0C9B5414C9CDDA67CC4FD5302',
    //   schoolName: '西柚测试中学',
    //   provinceId: '440000',
    //   cityId: '441900',
    //   districtId: '441907',
    //   loginAccount: '82037766',
    //   parentId: null,
    //   kinshipTerms: null,
    //   sequence: null,
    //   userType: null,
    //   expire: null,
    //   expireAt: '2023-10-09 00:00:00',
    //   memberType: 73671,
    //   type: 0,
    //   initialLetter: 83
    // },
    {
      id: '50D31E6095DB44748D055731C81F92FE',
      realName: '韦逸远',
      name: '韦逸远',
      head: 'https://xiyou-sys-dev.oss-cn-shenzhen.aliyuncs.com/sys_head/student_default.png',
      phone: '13712345678',
      gradeId: '7',
      clazzId: '07b16955bf41a8a5d6e05eeff129ae85',
      className: '舔狗班',
      actStatus: 0,
      stutus: 0,
      schoolId: 'EB996DD0C9B5414C9CDDA67CC4FD5302',
      schoolName: '西柚测试中学',
      provinceId: '440000',
      cityId: '441900',
      districtId: '441907',
      loginAccount: '76484123',
      parentId: null,
      kinshipTerms: null,
      sequence: null,
      userType: null,
      expire: null,
      expireAt: '2023-09-23 00:00:00',
      memberType: 15212,
      type: 1,
      initialLetter: 87
    }
  ]
}

export const wordData = {
  rootsList: '[{"value":"wonder","key":"词根： "},{"value":" 奇妙的；非凡的","key":"wonder"}]',
  groupsList:
    '[{"value":" 美妙人生（电视剧）","key":"wonderful life"},{"value":" 玩得快活极了","key":"have a wonderful time"},{"value":" 许多美好的记忆","key":"wonderful memories"}]',
  discriminateList:
    '[{"tip":"这组词都有“惊人的，奇异的，奇妙的”的意思，其区别是：","title":"marvelous, wonderful","list":[{"value":" 语气较强，指人的行为超凡或事物的异常，几乎使人难以相信。","key":"marvelous"},{"value":" 指人或事物的罕见或新奇，出人意料。","key":"wonderful"}]}]',
  conllinsList:
    '[{"spell":"/ˈwʌndəfʊl/","star":"4","name":"wonderful","rank":"CET4 TEM4","title":"","numList":[{"subTitle":"1. ADJ If you describe something or someone as wonderful, you think they are extremely good. 极好的","exampleList":[{"value":"那凉凉的雾气使他脸上感觉好极了。","key":"例： The cold, misty air felt wonderful on his face. "},{"value":"见到你好极了。","key":"例： It\'s wonderful to see you. "}]},{"subTitle":"2. wonderfully ADV 极好地","exampleList":[{"value":"它是一个运行极好的系统。","key":"例： It\'s a system that works wonderfully well. "}]}]}]'
}
